import { IMissionPlan } from '../missionPlan/IMissionPlan'
import { MissionPlanUiState } from '../../ui/MissionPlanUiState'
import { IGliderConfig, getDefaultGliderConfig } from './IGliderConfig'
import { SimulationMode } from '@/enum/SimulationMode'
import { ISmartSimulationBase, getDefaultSmartSimulationBase, isReadyForSimulationBase } from './ISmartSimulationBase'

export interface ISmartSimulation extends ISmartSimulationBase {
  gliders_config: Array<IGliderConfig>
  mission_plan: IMissionPlan
  wpt_init: Array<number> | null
}

export function getDefaultSmartSimulation({
  templateSimId = null,
  processing_mode = SimulationMode.simulator,
  mission_start_date = '',
  glider_type = 'SEAEXPLORER',
  battery_type = 'pack 18650',
  bms_type = 'neogy',
  enable_science_files = false,
  wpt_init = null as Array<number> | null,
  surfacing_time = 300,
  mission_plan = MissionPlanUiState.getDefaultMissionPlan(),
  current_cycle = 1,
  gliders_config = [getDefaultGliderConfig()],
} = {}): ISmartSimulation {
  return {
    ...getDefaultSmartSimulationBase({
      templateSimId,
      processing_mode,
      mission_start_date,
      glider_type,
      battery_type,
      bms_type,
      enable_science_files,
      surfacing_time,
      current_cycle,
    }),
    mission_plan,
    gliders_config,
    current_cycle,
    wpt_init,
  }
}

//retourne une liste de code d'erreur si le smartSimulation n'est pas valide
//si valide pour la simulation le tableau est vide
export function isReadyForSimulation(data: ISmartSimulation | null): Array<string> {
  const simuErrorCode = isReadyForSimulationBase(data)
  if (!data?.mission_plan?.steps?.length) simuErrorCode.push('MissingSteps')
  if (!((data?.mission_plan?.cur_step ?? -1) > -1)) simuErrorCode.push('MissingCurrentStep')
  else if (data?.mission_plan.steps.findIndex(s => s.id == data?.mission_plan?.cur_step) == -1)
    simuErrorCode.push('MissingCurrentStep')
  if (data?.mission_plan?.steps?.some(s => !((s?.prfNav_id ?? -1) > -1))) simuErrorCode.push('MissingProfilNavOnStep')
  if (
    data?.mission_plan?.payload?.length &&
    data?.mission_plan?.steps?.some(s => s?.payload_enable && !((s?.prfSci_id ?? -1) > -1))
  )
    simuErrorCode.push('MissingProfilSciOnStep')
  return simuErrorCode
}
